import React, { useEffect } from 'react';
import {
  Button,
  Text,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'components/core';
import { Stack } from 'components/layout';

export const useCustomMeasureWarningDialog = (
  template:
    | {
        updated_at?: string;
        consolidated_measures_labels_modified: boolean;
      }
    | undefined,
  setModalfn: any
) => {
  useEffect(() => {
    if (
      template &&
      template.updated_at && // Only for published templates
      template.consolidated_measures_labels_modified
    ) {
      setModalfn(
        <Modal isOpen={true} onClose={() => setModalfn(null)}>
          <ModalHeader>We&apos;ve updated your custom data formats</ModalHeader>
          <ModalBody>
            <Stack spacing={6}>
              <Text>
                Custom data formats are now stored in a single list across all
                result data types (continuous, dichotomous, qualitative), making
                them easier to manage.
              </Text>
              <Text>
                To avoid confusion with standard formats (like mean, SD, or
                total), we&apos;ve added &quot;(custom)&quot; to any custom
                formats with overlapping names.
              </Text>
              <Text>You can rename these anytime.</Text>
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button type="brand" onClick={() => setModalfn(null)}>
              Thanks, got it
            </Button>
          </ModalFooter>
        </Modal>
      );
      setTimeout(() => {
        // wait 300ms to ensure rendering complete
        const outcomesAccordion = Array.from(
          document.querySelectorAll('[role="region"]')
        ).find((accordion) => accordion.textContent?.includes('Outcomes'));

        if (outcomesAccordion) {
          const openButton = outcomesAccordion.querySelector(
            'button[aria-label="open"]'
          );
          if (openButton) {
            // if the accordion is already open, button won't be found
            (openButton as HTMLElement).click();
          }
          outcomesAccordion.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }, 300);
    }
  }, [template]);
};
